import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./TileButton.css";


const TileButton = ({ color, icon, name, link, index }) =>{
    return (
      <div
          className="col-sm-10 col-lg-4 col-xl-3 pl-3 mt-3 tile-button"
          key={"main_screen_btn_col_" + index}
          // style={{ height: "80vh"}}
        >
          <div className="tile-button__surface">
            {/*glassed*/}
            <Link
              to={link}
              // style={{ height: "70px" }}
              className={`btn btn-outline-${color} btn-block m-0 tile-button__link`}
              key={"main_screen_btn_" + index}
            >
              <i className={`fa fa-${icon} tile-button__watermark`}></i>
              <span className="tile-button__label">{name}</span>
            </Link>
          </div>
        </div>
    );
  }

  export default TileButton;